import React from 'react';
import { CloseIcon } from '@domain-group/fe-co-icon';
import * as styles from './modal-window.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ModalWindow = _ref => {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'minimal' : _ref$appearance,
    children = _ref.children,
    closeRef = _ref.closeRef,
    height = _ref.height,
    _ref$hideXToClose = _ref.hideXToClose,
    hideXToClose = _ref$hideXToClose === void 0 ? false : _ref$hideXToClose,
    idealHeight = _ref.idealHeight,
    idealWidth = _ref.idealWidth,
    innerStyle = _ref.innerStyle,
    isAnimated = _ref.isAnimated,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    onClose = _ref.onClose,
    width = _ref.width;
  var modalStyles = {};
  if (width || idealWidth) {
    modalStyles.width = width || idealWidth;
    modalStyles.maxWidth = width;
  }
  if (height || idealHeight) {
    modalStyles.height = height || idealHeight;
    modalStyles.maxHeight = height;
  }
  return ___EmotionJSX("div", {
    css: styles.modalInner({
      loading,
      appearance,
      animated: isAnimated
    }),
    style: innerStyle
  }, hideXToClose ? null : ___EmotionJSX("div", {
    css: styles.modalControls({
      appearance,
      isMobile: false,
      loading
    })
  }, ___EmotionJSX("button", {
    "data-testid": "modal-controls",
    type: "button",
    css: styles.modalClose(appearance),
    "aria-label": "Close overlay",
    onClick: onClose,
    ref: element => closeRef(element, 'desktop')
  }, ___EmotionJSX(CloseIcon, null))), ___EmotionJSX("div", {
    "data-testid": "modal-content",
    "aria-hidden": "false",
    role: "dialog",
    "aria-label": "modal window",
    css: styles.modalContent(loading, appearance),
    style: modalStyles
  }, hideXToClose ? null : ___EmotionJSX("div", {
    css: styles.modalControls({
      appearance,
      isMobile: true,
      loading
    })
  }, ___EmotionJSX("button", {
    "data-testid": "modal-controls-mobile",
    type: "button",
    css: styles.modalClose(appearance),
    "aria-label": "Close overlay",
    onClick: onClose,
    ref: element => closeRef(element, 'mobile')
  }, ___EmotionJSX(CloseIcon, null))), children));
};